var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgD6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 56,
    viewBox: "0 0 40 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 56,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 56,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7037 23.132C15.7037 26.044 17.2377 27.708 20.0457 27.708C22.8537 27.708 24.3877 26.044 24.3877 23.132V19.804C24.3877 17.126 23.3217 15.644 21.2157 15.644C19.9417 15.644 19.1097 16.19 18.6157 17.23H18.5637V13.928C18.5637 12.186 19.1357 11.692 20.1497 11.692C21.0597 11.692 21.6317 12.186 21.6317 13.486V14.136H24.3357V13.668C24.3357 10.756 22.8797 9.09204 20.0717 9.09204C17.1077 9.09204 15.7037 10.756 15.7037 13.824V23.132ZM20.0457 18.244C20.9557 18.244 21.5277 18.738 21.5277 20.038V23.314C21.5277 24.614 20.9557 25.082 20.0457 25.082C19.1357 25.082 18.5637 24.614 18.5637 23.314V20.038C18.5637 18.738 19.1357 18.244 20.0457 18.244Z",
    fill: "#DC3059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0566 33.1666L25.3333 40.4622L19.9433 47.8333L14.6666 40.5378L20.0566 33.1666Z",
    fill: "#DC3059"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD6);
export default __webpack_public_path__ + "static/media/D6.43ac680e1f06650c0526471ca25aa237.svg";
export { ForwardRef as ReactComponent };